import styles from './Loader.module.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const Loader = ({
  size = "medium",
  className = ""
}) => {
  const wrapperCssClasses = `${styles.wrapper} ${styles[size]} ${className}`;
  return /* @__PURE__ */ jsxs("div", {
    className: wrapperCssClasses,
    "data-test-id": "loader",
    role: "progressbar",
    "aria-label": "Loading",
    "aria-live": "polite",
    "aria-busy": "true",
    children: [/* @__PURE__ */ jsx("div", {
      className: styles.circle
    }), /* @__PURE__ */ jsx("div", {
      className: styles.circle
    }), /* @__PURE__ */ jsx("div", {
      className: styles.circle
    })]
  });
};

export { Loader as default };
//# sourceMappingURL=Loader.js.map
